import React, {useState, useEffect, useRef} from 'react'
import { Header } from '../Custom/Blosomall'


export default function AutoMenuHeader ({locations, restId}) {
    if (!locations || locations.length <= 1) {
        return null
    }
    const thisLocation = locations ? locations.find(loc => loc.shopId === restId) : null
    const {label, address, phone, hours} = thisLocation || {}
    const address_line_1 = address ? address[0] : ''
    const address_line_2 = address ? address[1] : ''
    return(
        <div className="auto-menu-location-header" style={{
            background: 'linear-gradient(135deg, #faaa1e 0%, #e8961b 100%)',
            color: 'white',
            padding: '24px',
            
            borderRadius: '12px',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
            marginBottom: '20px',
            margin: '0 0.5em',
        }}>
            <div className="location-info" style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: '20px',
                flexWrap: 'wrap'
            }}>
                <div className="location-details" style={{
                    flex: '1',
                    minWidth: '200px'
                }}>
                    <h3 className="location-name" style={{
                        margin: '0 0 12px 0',
                        fontSize: '1.5rem',
                        fontWeight: '600',
                        color: 'white'
                    }}>{label}</h3>
                    <div className="location-address" style={{
                        fontSize: '0.95rem',
                        opacity: '0.9',
                        lineHeight: '1.4'
                    }}>
                        <div>{address_line_1}</div>
                        {address_line_2 && <div>{address_line_2}</div>}
                    </div>
                </div>
                <div className="location-switcher" style={{
                    minWidth: '200px'
                }}>
                    <select 
                        defaultValue="non"
                        onChange={(e) => {
                            if (e.target.value) {
                                const selectedLocation = locations.find(loc => loc.shopId === e.target.value);
                                if (selectedLocation && selectedLocation.orderLink) {
                                    window.location.href = selectedLocation.orderLink;
                                }
                            }
                        }}
                        style={{
                            width: '100%',
                            padding: '12px 16px',
                            border: 'none',
                            borderRadius: '8px',
                            fontSize: '1rem',
                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                            color: '#333',
                            cursor: 'pointer',
                            outline: 'none',
                            transition: 'all 0.3s ease',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
                        }}
                    >
                        <option value="non" disabled>Change location...</option>
                        {locations.map(location => (
                            <option key={location.shopId} value={location.shopId}>
                                {location.label} - {location.address?.[0]}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
        </div>
    )
}
